module.exports = __webpack_public_path__ + "media/images/talent/case-arrow-ab1ffd3de62459648238bfc6fe9d0ba1.png";